import { trackAddPromoCodeEvent } from '@apps-once/composables/track';

/**
 * Fires one PROMOTION_ADD_* event per distinct promo code in a purchase.
 *
 * The backend receives the joined coupon string unchanged; this only fans the
 * tracking out per code. Codes are deduped case-insensitively so a repeated
 * code in the joined string is never tracked twice, and each event is tagged
 * with whether that specific code was auto-applied (vs user-typed).
 *
 * @param {Object} params
 * @param {string} params.eventName - PROMOTION_ADD_REQUESTED | _SUCCESS_ACKNOWLEDGED | _FAILURE_ACKNOWLEDGED
 * @param {string} params.eventScreen
 * @param {string} params.eventSource
 * @param {string} [params.promoCodes] - Comma-joined coupon codes for the purchase
 * @param {string} [params.errorMessage]
 * @param {string[]} [params.autoAppliedCodes] - Codes applied automatically (quoteStore.autoAppliedCodes)
 */
export function trackPromotionAddEvents({
  eventName,
  eventScreen,
  eventSource,
  promoCodes,
  errorMessage,
  autoAppliedCodes = [],
}) {
  const autoAppliedSet = new Set(
    autoAppliedCodes.map(code => code?.toUpperCase()).filter(Boolean)
  );

  // Split the joined string, drop blanks, and dedupe case-insensitively so a
  // repeated code is never tracked twice.
  const seen = new Set();
  const codes = [];
  for (const rawCode of (promoCodes || '').split(',')) {
    const code = rawCode.trim();
    const key = code.toUpperCase();
    if (code && !seen.has(key)) {
      seen.add(key);
      codes.push(code);
    }
  }

  codes.forEach(code => {
    trackAddPromoCodeEvent({
      eventName,
      eventScreen,
      eventSource,
      promoCode: code,
      errorMessage,
      isAutoApplied: autoAppliedSet.has(code.toUpperCase()),
    });
  });
}
